export default {
  database: {
    tableName: "Table name",
    actions: "Actions",
    noData: "No data available",
    viewTable: "View table {table}",
    settingsTablePlaceCounter: "Counter slot settings",
    import: {
      importFileTitle: "Import data into the table",
      chooseFile: "Import a file",
      filePreview: "File content (preview of first 5 lines):",
    }
  }
};
